<template>
  <div>
    <div class="dashboard page-content__header-description">
      <h1 style="flex: 1" class="page-title">Access Requests</h1>
      <div class="top-actions">
        <div class="left-side">
          <span class="label-container">
            <div>
              <span @click="toggleAll">
                <p
                  class="default-label"
                  :class="{ is_active: selectedStatus === 'all' }"
                >
                  All
                </p>
              </span>
            </div>
            <div>
              <span @click="togglePendings">
                <p
                  class="default-label"
                  :class="{ is_active: selectedStatus === 'pending' }"
                >
                  Pendings
                </p>
              </span>
            </div>
            <div>
              <span @click="toggleApproves">
                <p
                  class="default-label"
                  :class="{ is_active: selectedStatus === 'accepted' }"
                >
                  Approves
                </p>
              </span>
            </div>
            <div>
              <span @click="toggleRejects">
                <p
                  class="default-label"
                  :class="{ is_active: selectedStatus === 'rejected' }"
                >
                  Rejects
                </p>
              </span>
            </div>
          </span>
        </div>
        <el-input
          style="width: 30%"
          class="el-input el-input--prefix"
          placeholder="Search by Partner's name"
          prefix-icon="el-icon-search"
          v-model="searchTerm"
          clearable
        ></el-input>
      </div>
    </div>

    <div v-if="loading">
      <animated-spinner-loader />
    </div>
    <!-- The Corresponding Table -->
    <div v-if="!loading" class="vue-table">
      <vue-good-table
        :columns="fields"
        :rows="getAllRequestAccess"
        :pagination-options="{ enabled: true }"
      >
        <template slot="table-row" slot-scope="props">
          <span class="name-tab" v-if="props.column.field == 'user'">
            {{
              props.row.user && props.row.user.firstName
                ? props.row.user.firstName
                : "----"
            }}
            {{
              props.row.user && props.row.user.lastName
                ? props.row.user.lastName
                : "----"
            }}
          </span>

          <span v-if="props.column.field == 'status'">
            {{ props.row.status }}
          </span>

          <span v-if="props.column.field == 'created_at'">
            {{ formatDate(props.row.created_at) }}
          </span>

          <span class="action" v-if="props.column.field == 'actions'">
            <button
              class="btn btn-outline-success"
              @click="updateStatus(props.row.id, 'accepted')"
              v-if="
                props.row.status == 'pending' || props.row.status == 'rejected'
              "
            >
              Accept
            </button>
            <button
              v-if="
                props.row.status == 'pending' || props.row.status == 'accepted'
              "
              class="btn btn-outline-primary"
              @click="updateStatus(props.row.id, 'rejected')"
            >
              Reject
            </button>
          </span>
        </template>

        <template slot="pagination-bottom" slot-scope="props">
          <grey-pagination
            :total="props.total"
            :pageChanged="props.pageChanged"
            :perPageChanged="props.perPageChanged"
            @paginated-info="paginationInfo = $event"
          ></grey-pagination>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import AnimatedSpinnerLoader from "@/components/AnimatedSpinnerLoader.vue";

export default {
  name: "RequestAccess",
  searchdata: "",
  components: {
    "animated-spinner-loader": AnimatedSpinnerLoader
  },
  computed: {
    getAllRequestAccess: {
      get() {
        return this.filteredAccessRequests;
      }
    }
  },
  data() {
    return {
      getUsers: [],
      accessRequests: [],
      selectedStatus: "all",
      searchTerm: "",
      filteredAccessRequests: [],
      loading: false,
      fields: [
        {
          field: "user",
          label: "Name",
          sortable: "true",
          width: "500px"
        },
        {
          field: "status",
          label: "Request Status",
          sortable: "true"
        },
        {
          field: "created_at",
          label: "Request Date",
          sortable: "true"
        },
        {
          field: "actions",
          label: "Action"
        }
      ]
    };
  },
  methods: {
    toggleAll() {
      this.filteredAccessRequests = this.accessRequests;
      this.selectedStatus = "all";
    },
    togglePendings() {
      this.filteredAccessRequests = this.accessRequests.filter(
        x => x.status === "pending"
      );
      this.selectedStatus = "pending";
    },
    toggleApproves() {
      this.filteredAccessRequests = this.accessRequests.filter(
        x => x.status === "accepted"
      );
      this.selectedStatus = "accepted";
    },
    toggleRejects() {
      this.filteredAccessRequests = this.accessRequests.filter(
        x => x.status === "rejected"
      );
      this.selectedStatus = "rejected";
    },
    updateStatus(requestId, status) {
      this.loading = true;
      const HTTP = this.$httpUtils.PartnerHTTP;
      const headers = {
        "Content-Type": "application/json",
        "x-user-role": localStorage.getItem("roleType")
      };
      HTTP.patch(
        `/admin/access-requests/${requestId}`,
        {
          status
        },
        { headers }
      )
        .then(res => {
          this.init();
        })
        .catch(err => {
          this.loading = false;
        });
    },
    formatDate(_date) {
      return moment(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    init() {
      this.loading = true;
      const HTTP = this.$httpUtils.PartnerHTTP;
      const headers = {
        "Content-Type": "application/json",
        "x-user-role": localStorage.getItem("roleType")
      };
      HTTP.get("/admin/access-requests", { headers })
        .then(res => {
          if (res && res.data) {
            this.accessRequests = res.data.map(x => ({ ...x, actions: "" }));
            this.filteredAccessRequests = this.accessRequests;
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    }
  },
  watch: {
    searchTerm: function(newVal) {
      this.filteredAccessRequests = this.accessRequests.filter(x =>
        `${x.user.firstName} ${x.user.lastName}`
          .toLowerCase()
          .includes(newVal.toLowerCase())
      );
    }
  },
  created() {},
  async mounted() {
    this.init();
  }
};
</script>

<style lang="scss">
h1,
h2,
p {
  margin: 0;
}
.dashboard {
  padding: 20px;
}
.page-content__header-description {
  margin: 0;
  padding-top: 0px;
  padding-bottom: 0px;
}
.page-title {
  margin: 50px 0;
  color: black;
}
.label-container {
  display: flex;
  div {
    margin-right: 10px;
  }
}

.default-label {
  border: 1px solid gray;
  border-radius: 12px;
  padding: 7px 14px;
  cursor: pointer;
  background-color: white;
  color: grey;
}
.default-label:hover {
  color: #fff;
  background-color: #444543;
  border-color: #d9d9d9;
}
.vue-table {
  margin: 20px;
}
.top-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left-side {
  display: flex;
}

.action button {
  padding: 8px 12px;
  border-radius: 6px;
  width: 130px;
  border: none;
}

// .accept_btn {
//   background-color: green;
//   color: white;
// }

// .reject_btn {
//   background-color: ;
//   color: white;
// }
.btn-outline-primary {
  border: 1px solid #1a93ca !important;
}
.btn-outline-success {
  border: 1px solid #28a745 !important;
}

.btn-outline-success:hover,
.btn-outline-primary:hover {
  color: #ffff;
}

.vue-table thead tr th:first {
  width: 500px !important;
}

.is_active {
  background-color: #444543;
  border-color: #d9d9d9;
  color: white;
}
.content-area {
  background-color: #f5f6f8 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/partnerAccess/RequestAccess.vue